import { Theme } from "@emotion/react";
import styled from "@emotion/styled";
import { Button } from "@mui/material";

interface BillToShipToBoxWrapperProps {
	hasBorder?: boolean;
	hasMinHeight?: boolean;
	hasSubtotal?: boolean;
	isInactiveBillTo?: boolean;
	hasDropdown?: boolean;
	showAckPricingInfo?: boolean;
}

const billToBorder = (theme: Theme, hasBorder?: boolean, isInactiveBillTo?: boolean) => {
	if (isInactiveBillTo) return theme.project.borders.presets.errorOutline;
	if (hasBorder) return theme.project.borders.presets.thinOutline;
	return "none";
};

export const BillToShipToBoxWrapper = styled.div<BillToShipToBoxWrapperProps>(
	({
		theme,
		hasBorder = false,
		hasMinHeight = false,
		hasSubtotal,
		isInactiveBillTo,
		hasDropdown,
		showAckPricingInfo
	}) => ({
		position: "relative",
		padding: 16,
		paddingBottom: showAckPricingInfo ? 32 : 16,
		border: billToBorder(theme, hasBorder, isInactiveBillTo),
		display: "flex",
		flexDirection: "column",
		minHeight: hasMinHeight ? "150px" : "auto",
		backgroundColor: theme.palette.background.default,
		b: {
			...theme.project.typography.subtitle.subtitle2,
			color: theme.palette.text.primary
		},
		p: {
			...theme.project.typography.body.body2,
			color: theme.palette.text.secondary
		},
		h6: {
			...theme.project.typography.subtitle.subtitle1,
			margin: "0 0 0.5rem 0",
			color: theme.palette.text.secondary
		},
		"> div": {
			display: "flex",
			width: "100%",
			gap: hasDropdown ? 16 : 24,
			[theme.breakpoints.down("sm")]: {
				flexDirection: "column",
				gap: "8px"
			},
			"> div": {
				width: hasSubtotal ? "50%" : "100%",
				[theme.breakpoints.down("sm")]: {
					width: "100%"
				},
				flexDirection: "column",
				gap: 0,
				p: {
					margin: 0
				}
			}
		}
	})
);

export const PricingContainer = styled.div({
	display: "flex",
	width: "100%",
	padding: "8px 0px",
	"& > div": {
		width: "100%"
	},
	p: {
		margin: 0
	}
});

export const BillToInactiveHelperContainer = styled.div(({ theme }) => ({
	color: theme.project.colors.semanticColors.error,
	marginBottom: 16,
	span: {
		fontSize: ".875rem"
	}
}));

export const PricingDefinitionButton = styled(Button)(({ theme }) => ({
	...theme.project.typography.body.body1,
	padding: 0,
	textDecoration: "underline",
	display: "flex",
	alignItems: "center",
	gap: "4px",
	position: "absolute",
	bottom: 16,
	svg: {
		height: 16
	}
}));
